import { twMerge } from "tailwind-merge";
import { SVGs } from "../assets";

export type StaticMapViewProps = {
  lat?: number;
  lng?: number;
  zoom?: number;
  className?: string;
  size?: {
    width: number;
    height: number;
  };
};

export default function StaticMapView({
  lat = 0,
  lng = 0,
  zoom = 12,
  className = "",
  size = {
    width: 400,
    height: 400,
  },
}: StaticMapViewProps) {
  const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${size.width}x${size.height}&key=${process.env.REACT_APP_GOOGLE_PLACES_API_KEY}`;
  return (
    <div className={twMerge("relative overflow-hidden", className)}>
      <div className="absolute top-0 left-0 bottom-0 right-0 z-10 flex items-center justify-center">
        <img
          src={SVGs.mapMarker}
          alt="Map marker"
          className="w-[35px] h-[35px]"
        />
      </div>
      <img
        src={mapUrl}
        className="w-full h-full"
        alt={`Map showing location at ${lat}, ${lng}`}
      />
    </div>
  );
}
